import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { FC, PropsWithChildren, SVGProps } from "react";

type InlineableSVGProps = PropsWithChildren<SVGProps<SVGSVGElement>> & {
    inline?: boolean;
} & PropsWithClassName;

/**
 * Use this component if you have a component that renders an SVG that you'd like to be able to inline into another SVG
 * so that the resulting svg only has one <svg> tag.
 *
 * This is convenient for icons like IconError where you sometimes want to render it stand-alone, but other times might want to embed
 * it into an existing component that has its own <svg> element. See StartSequenceStepIcon for an example.
 */
export const InlineableSVG: FC<InlineableSVGProps> = ({ inline, children, ...props }) => {
    if (inline) {
        return <g className={props.className}>{children}</g>;
    }

    return <svg {...props}>{children}</svg>;
};
